import { FormControl, Validators } from '@angular/forms';
import { InvoiceDeliverable } from '@teem/models/invoice-deliverable';

export class InvoiceDeliverableForm {
	uuid = new FormControl();
	id = new FormControl();
	title = new FormControl('', [Validators.required]);
	description = new FormControl();
	quantity = new FormControl(0, [Validators.required, Validators.min(1)]);
	quantity_type = new FormControl('pcs');
	rate = new FormControl(0, [Validators.required, Validators.max(99000000)]); 
	is_taxable = new FormControl(true);
	edit: boolean = false;
	add_to_store = new FormControl(false);;
	submitted: boolean = false;
	available_quantity = new FormControl(0);
	type = new FormControl();

	constructor(deliverable: InvoiceDeliverable) {
		if (deliverable.uuid)
			this.uuid.setValue(deliverable.uuid);

		this.title.setValue(deliverable.title);
		this.description.setValue(deliverable.description);		
		this.quantity.setValue(deliverable.quantity);
		this.quantity_type.setValue(deliverable.quantity_type);
		this.rate.setValue(deliverable.rate);
		this.is_taxable.setValue(deliverable.is_taxable);
		this.add_to_store.setValue(deliverable.add_to_store);
		this.id.setValue(deliverable.id);
		this.available_quantity.setValue(deliverable.available_quantity);
		this.type.setValue(deliverable.type);
	}

	get cost() {
		return this.quantity.value * this.rate.value;
	}
}
